<script setup lang="ts">
import { ActionButton, Card, StatusTag } from '@taler/ui'
import { RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'
import type { LedgerMembership } from '../internal/types.ts'

defineProps<{
  isAccepting: boolean
  error: Error | null
  membership: LedgerMembership | undefined
}>()

const emit = defineEmits<{ accept: [] }>()

const { t } = useI18n()
</script>

<template>
  <Card padding="block" class="flex flex-col items-start gap-[var(--space-group)]">
    <template v-if="membership">
      <StatusTag tone="ok">{{ t('invitationAccept.successTitle') }}</StatusTag>
      <p class="text-[color:var(--color-text-muted)]">
        {{ t('invitationAccept.successBody', { role: membership.role }) }}
      </p>
      <ActionButton :as="RouterLink" :to="{ name: 'transactions' }">
        {{ t('invitationAccept.continueAction') }}
      </ActionButton>
    </template>

    <template v-else>
      <p class="text-[color:var(--color-text-muted)]">{{ t('invitationAccept.body') }}</p>
      <ActionButton type="button" :disabled="isAccepting" @click="emit('accept')">
        {{ isAccepting ? t('invitationAccept.accepting') : t('invitationAccept.acceptAction') }}
      </ActionButton>

      <StatusTag v-if="error" tone="danger" role="alert">
        {{ t('invitationAccept.errorTitle') }}
      </StatusTag>
      <p v-if="error" class="text-[color:var(--color-text-muted)]">{{ t('invitationAccept.errorBody') }}</p>
    </template>
  </Card>
</template>
